import './Team.css';
import Navbar from '../../components/navbar/Navbar';

function Team() {
  return (
    <div>
        <Navbar/>
        <h1 className="team-intros">
            HIHIHI
        </h1>
    </div>
  );
}

export default Team;